import axios from "axios";
import { Base_URL } from "../url";

export const getTeamDetails = async (userId, orgId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/Leave/GetTeamDetails?userId=${userId}&orgId=${orgId}`
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching team details", error);
    throw error;
  }
};

export const getLeaveBalances = async (
  resourceId,
  orgId
) => {
  try {
    const response = await axios.get(
      `${Base_URL}/Leave/GetLeaveBalances?ResourceId=${resourceId}&orgId=${orgId}`
    );

    return response.data;
  } catch (error) {
    console.error("Error fetching leave balances", error);
    throw error;
  }
};

export const applyLeave = async (payload) => {
  try {
    const response = await axios.post(
      `${Base_URL}/Leave/ApplyLeaveNew`,
      payload
    );

    return response.data;
  } catch (error) {
    console.error("Error applying leave", error);
    throw error;
  }
};

export const validateLeave = async (payload) => {
  try {
    const response = await axios.post(
      `${Base_URL}/Leave/ValidateLeave`,
      payload
    );

    return response.data;
  } catch (error) {
    console.error("Validation error", error);
    throw error;
  }
};